import { useEffect, useRef, useState } from 'react';

type TruncatedTextProps = {
  text: string;
  className?: string;
};

export function TruncatedText({ text, className = '' }: TruncatedTextProps) {
  const textRef = useRef<HTMLSpanElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const checkTruncation = () => {
      const element = textRef.current;
      if (!element) return;
      setIsTruncated(element.scrollWidth > element.clientWidth);
    };

    checkTruncation();

    const resizeObserver =
      typeof ResizeObserver !== 'undefined'
        ? new ResizeObserver(() => checkTruncation())
        : null;

    if (resizeObserver && textRef.current) {
      resizeObserver.observe(textRef.current);
    } else {
      window.addEventListener('resize', checkTruncation);
    }

    return () => {
      if (resizeObserver) {
        resizeObserver.disconnect();
      } else {
        window.removeEventListener('resize', checkTruncation);
      }
    };
  }, [text]);

  return (
    <span
      ref={textRef}
      title={isTruncated ? text : undefined}
      className={`block min-w-0 truncate ${className}`}
    >
      {text}
    </span>
  );
}
